import StockImagesPanel from './StockImagesPanel.vue';
import { t } from './i18n';

type VeyopFacade = {
  hooks?: {
    on?: (event: string, handler: (payload?: unknown) => void) => unknown;
  };
  designer?: {
    registerLeftPanel?: (panel: {
      id: string;
      label: string;
      description?: string;
      icon?: string | { type: 'stroke' | 'material'; path: string };
      priority?: number;
      group?: string;
      render: (context: { config: Record<string, unknown>; activeView: string }) => { component: unknown; props?: Record<string, unknown> };
    }) => unknown;
  };
};

let registered = false;

function register(Veyop: VeyopFacade): void {
  if (registered || !Veyop.designer?.registerLeftPanel) return;
  registered = true;
  Veyop.designer?.registerLeftPanel?.({
    id: 'stock-images',
    group: 'images',
    label: t('Stock'),
    description: t('Browse licensed photos'),
    icon: {
      type: 'material',
      path: 'M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q25-92 100-149t170-57q117 0 198.5 81.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm0-80h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-83-58.5-141.5T480-720q-83 0-141.5 58.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41Zm220-240Z',
    },
    priority: 35,
    render: (context) => ({ component: StockImagesPanel, props: { context } }),
  });
}

function boot(): void {
  const w = window as unknown as { Veyop?: VeyopFacade };
  const tryRegister = () => {
    if (w.Veyop) register(w.Veyop);
  };
  tryRegister();
  w.Veyop?.hooks?.on?.('veyop:designer:ready', tryRegister);
  const start = Date.now();
  const timer = window.setInterval(() => {
    tryRegister();
    if (registered || Date.now() - start > 5000) window.clearInterval(timer);
  }, 50);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
else boot();
